import { TeacherSearchSuggestions } from "@outschool/gql-backend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

import {
  TeacherSearchSuggestionsQuery,
  TeacherSearchSuggestionsQueryVariables,
} from "../../../shared/generated/graphql";

const TeacherSuggestionsQuery = gql`
  query TeacherSearchSuggestions(
    $query: String!
    $fundingProgram: String
    $size: Int
  ) {
    teacherSearchSuggestions(
      search: { query: $query }
      fundingProgram: $fundingProgram
      size: $size
    ) {
      teachers {
        uid
        name
        photo
        leader_link
        averageActivityStarRating
        reviewCount
        educatorTiers
      }
      term
    }
  }
`;

export function useTeacherSearchSuggestions(
  query: string,
  size: number,
  fundingProgram?: string | null,
): TeacherSearchSuggestions {
  const { data } = useQueryWithPreviousData<
    TeacherSearchSuggestionsQuery,
    TeacherSearchSuggestionsQueryVariables
  >(TeacherSuggestionsQuery, {
    variables: { query, fundingProgram, size },
    skip: !query || !query.length,
  });

  if (!data) {
    return {
      teachers: [],
      term: "",
    };
  }

  const { teacherSearchSuggestions } = data;
  return teacherSearchSuggestions as TeacherSearchSuggestions;
}
